export default __webpack_public_path__ + "static/media/tamara.966ef61c.svg";